import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@design-system-etat/dsfr-react';
import * as PropTypes from 'prop-types';

const AlerteAutoClosed = ({ titre, type, description, onClose }) => {
    const role = type === 'error' || type === 'warning' ? 'alert' : 'status';

    return (
        <Alert severity={type} role={role} size="md" onClose={onClose}>
            <AlertTitle>{titre}</AlertTitle>
            <AlertDescription>{description}</AlertDescription>
        </Alert>
    );
};

AlerteAutoClosed.propTypes = {
    titre: PropTypes.string,
    type: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    onClose: PropTypes.func.isRequired,
};

export default AlerteAutoClosed;
